import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '@/hooks/useAuth';
import { useIdleLogout } from '@/hooks/useIdleLogout';
import { PageSpinner } from '@/components/ui/Spinner';

export default function AppLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  // Auto-logout after 10 minutes of inactivity (active users are unaffected).
  useIdleLogout();

  if (isLoading) return <PageSpinner />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar />
      <main
        className="flex-1 overflow-y-auto p-4 pt-14 sm:p-6 sm:pt-14 lg:p-8 lg:pt-8"
        id="main-content"
      >
        <div className="mx-auto max-w-7xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
